
import { getGlobal, isNodeJS } from "./compat";

var g = getGlobal();
var _window = g;
var _document = _window && _window.document;

g.LOCALIZATION_REL_PATH = "";

/**
 * Contains the SDK's version.
 *
 * @type {string}
 * @global
 */
g.DT_SDK_VERSION = BUILD_FLAG__BUILD_VERSION;

if (g.DT_SDK_VERSION.charAt(0) === 'v') {
  // remove prefixed 'v'
  g.DT_SDK_VERSION = g.DT_SDK_VERSION.substr(1);
}

let source,sep = '/';
if (BUILD_FLAG__IS_NODE) {
  source = __filename;
  sep = require('path').sep;
} else {
  const currentScript = g.document?.currentScript; // Normal script tag
  const importMeta = g.import?.meta; // Module script tag
  source = currentScript ? currentScript.src : importMeta ? importMeta.url : '';
}

export const DT_RESOURCE_ROOT = g.DT_RESOURCE_ROOT = source.substring(0, Math.max(source.lastIndexOf(sep) + 1, 0));

try {
  Object.defineProperty(g, 'DT_RESOURCE_ROOT', {
    get: () => {
      return DT_RESOURCE_ROOT;
    },
    set: () => {
      console.warn('Setting DT_RESOURCE_ROOT is deprecated. This will do nothing.');
    }
  });
} catch (e) {

  // Ignore. This only happens in our node.js unit tests.
}
// TODO:  This is here for now, until we find a better place for it.
//
/**
 * Returns the first source url found containing the given script name.
 *
 * @private
 * @param {string} scriptName - Script name.
 * @returns {HTMLScriptElement} The script element whose source location matches the input parameter.
 */
export function getScript(scriptName) {
  scriptName = scriptName.toLowerCase();
  var scripts = _document.getElementsByTagName('SCRIPT');
  if (scripts && scripts.length > 0) {
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].src && scripts[i].src.toLowerCase().indexOf(scriptName) !== -1) {
        return scripts[i];
      }
    }
  }
  return null;
}

/**
 * Returns the full url of a resource.
 *
 * @private
 * @param {string} resourceRelativePath - The path of the resource relative to DT_RESOURCE_ROOT.
 * @returns {string} The full resource path.
 */
export function getResourceUrl(resourceRelativePath) {
  return DT_RESOURCE_ROOT + resourceRelativePath;
}

/**
 * Returns the query parameter value from window url
 * @param {string} name - Parameter name
 * @returns {string} - Parameter value
 * @alias Autodesk.Viewing.getParameterByName
 */
export function getParameterByName(name) {
  if (typeof window === "undefined") {
    return "";
  }
  return getParameterByNameFromPath(name, _window.location.href);
}

/**
 * Parameter from url
 * @param {string} name - Parameter name
 * @param {string} url - URL
 * @returns {string} - Parameter value
 * @alias Autodesk.Viewing.getParameterByNameFromPath
 */
export function getParameterByNameFromPath(name, url) {
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(url);
  if (results == null)
  return "";else

  return decodeURIComponent(results[1].replace(/\+/g, " "));
}

/**
 * Creae a dom element
 * @param {string} str - String to generate DOM object
 * @private
 */
export function stringToDOM(str) {
  var d = _document.createElement("div");
  d.innerHTML = str;
  return d.firstChild;
}